module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-10.8be6dc78.png";